<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      userKeybeTimeZone: state => state.auth.userKeybeTimeZone
    })
  },
  methods: {
    convertTZ (date, timeZone = 'UTC') {
      return this.$moment.tz(date, timeZone)
    },
    convertTZToUserTZ (date) {
      return this.convertTZ(date, this.userKeybeTimeZone.label)
    }
  }
}
</script>
